<div class="headbar" [ngClass]="{ scrolled: isScrolled }">
  <h1>
    <i
      *ngIf="headBarService.routeBackButtonCallback"
      class="pi pi-arrow-left"
      (click)="headBarService.routeBackButtonCallback()"></i>

    {{ headBarService.currentHeadBarTitle }}
  </h1>
</div>
